import '@core/utils/prototypes';
import { JustificativaExtracaoRelatorio } from './justificativa-extracao';
import { StatusUsuario, StatusUsuarioEnum } from './status-usuario';
import { PerfilUsuario } from './perfil-usuario';
import { PerfilEnum } from './perfil';


export class UsuarioFiltro  extends JustificativaExtracaoRelatorio{
  pessoaRepresentada?: {
    nome?: string;
  };
  nome?: string;
  login?: string;
  email?: string;
  status?: StatusUsuarioEnum;
  autenticaEmDuasEtapas?: boolean;
  receberEmail?: boolean;
}

export interface UsuarioCombo {
  id: number;
  nomeUsuario: string;
}


export interface UsuarioElement {
  autenticaEmDuasEtapas: boolean;
  receberEmail: boolean;
  email: string;
  id: number;
  perfil?:any;
  nome: string;
  dataCadastro: string;
  status: StatusUsuario;
  login?: string;
  pessoaRepresentada?: PessoaRepresentada;
  roles:any[];
}

export interface PessoaRepresentada {
  id: number;
  nome: string;
}


export class UsuarioCadastro {
  constructor(obj?: any) {
    Object.assign(this, obj);
  }

  id: any;
  login?: string;
  nome?: string;
  senha?: string | null;
  email?: string;
  idPessoa?: number | null;
  status?: any
  dataCadastro?: string;
  dataUltimoAcesso?: string;
  token?: string;
  roles?: string[];
  autenticaEmDuasEtapas?: boolean;
  receberEmail?: boolean;
  perfil?: any;
  senhaExpirado?: boolean;
}

export class UsuarioMeusDados {
  constructor(obj?: any) {
    Object.assign(this, obj);

  }

  id: any;
  login?: string;
  nome?: string;
  senha?: string | null;
  email?: string;
  idPessoa?: number | null;
  status?: any
  dataCadastro?: string;
  dataUltimoAcesso?: string;
  token?: string;
  roles?: string[];
  autenticaEmDuasEtapas?: boolean;
  receberEmail?: boolean;
  perfil?: any;
  senhaExpirado?: boolean;
}

export interface Usuario {
  id: number;
}

export interface AlteracaoSenha {
  confirmNewSenha: string;
  newSenha: string;
  newSenhaValid: true;
  senha: string;
  valid: boolean;
}

